class window.YaMap
  constructor: (selector_id) ->
    self = this
    @mapSelector = selector_id
    @latitude = 55.714176
    @longitude = 84.932817
    @zoom = 17
    @yaMap = undefined
    @yMaps = ymaps

    @init()

  init: =>
    self = this

    if $('#' + @mapSelector)[0] != undefined
      @yMaps.ready ->
        self.yaMap = new self.yMaps.Map(self.mapSelector, {
          center: [self.latitude, self.longitude]
          zoom: self.zoom
        })

        myPlacemark = new self.yMaps.Placemark(
          [self.latitude, self.longitude],
          {
            balloonContent: '<p>'+"Администрация города Юрги"+'</p>'
          }
        )

        self.yaMap.behaviors.disable('scrollZoom')
        self.yaMap.behaviors.disable('drag')
        self.yaMap.geoObjects.add(myPlacemark)


// WEBPACK FOOTER //
// ./assets/javascripts/app/ya_map.coffee